import * as React from 'react';
import {SVGSource} from '@shopify/images';
import * as icons from './icons';

export type IconType = keyof typeof icons | '';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon?: IconType;
  sourceSVG?: SVGSource;
  size?: number;
  fill?: string;
  alt?: string;
  style?: React.CSSProperties;
}

export function Icon({
  icon = '',
  sourceSVG,
  size = 12,
  fill,
  alt = '',
  style: propsStyle = {},
  className,
  ...restProps
}: IconProps) {
  const iconSource = sourceSVG || icons[icon] || {};

  const style = Object.assign({}, {
    color: fill || 'inherit',
  }, propsStyle);

  return (
    <svg
      style={style}
      width={size}
      height={size}
      fill={fill}
      aria-label={alt}
      className={className}
      {...restProps}
      viewBox={iconSource.viewBox}
      dangerouslySetInnerHTML={{__html: iconSource.body}}
    />
  );
}

export default Icon;
